import z from "zod";

import {
  basicValidator,
  dateValidator,
  numberValidator,
  reactSelectValidator,
  singleSelectValidator,
} from "@/lib/validators";

const invoicingSchema = z.object({
  id: z.string().optional(),
  referenceNumber: basicValidator(false, "Required", 0, 10),
  dueDate: dateValidator(),
  action: z.string().default("create").optional(), //This is to track the action of the form
  status: z.string().optional(), //This is  just to track status
  projectId: z.string().optional(),
  customerId: z.string().optional(), //This is used for tracking customerId and it is only used for docket invoicing
  invoiceFor: z.string().optional(), //This is used to track the invoicing for Docket or Contract
  selectedDocketIds: z.array(z.string().uuid()).optional(), //This is to track the selected dockets while adding new dockets to the invoiced dockets with status of DRAFT
  itemSheets: z.array(
    z.object({
      itemDetailId: z.string().optional(),
      itemId: singleSelectValidator(false),
      defaultItemName: z.string().optional(),
      title: z.string(),
      description: basicValidator(true, "Description is required"),
      price: numberValidator({
        required: false,
      }),
      quantity: numberValidator({
        required: false,
      }),
      discount: numberValidator({
        required: false,
      }),
      trackingName: singleSelectValidator(false),
      trackingOption: singleSelectValidator(false),
      account: basicValidator(false, "Required", 0, 50),
      tax: numberValidator({
        required: false,
        max: 100,
        messages: {
          max: "Tax should be less than 100%",
        },
      }),
      total: numberValidator({
        required: false,
        maxChars: 100,
      }),
      docketId: z.string().uuid().optional(),
      isDraftDocket: z.boolean().optional(), //This is used to track the items which are added to the invoicing dockets with status of DRAFT
    }),
  ),
  notes: basicValidator(false, "Required", 0, 50),
  documents: z
    .array(
      z
        .instanceof(File, {
          message: "Required",
        })
        .or(z.string())
        .optional(),
    )
    .optional(),
  total: z.coerce.number().optional(),
});

export const addDocketInvoicingSchema = z.object({
  selectedDockets: reactSelectValidator("Please select Dockets", false),
});

export const emptyInvoicingItems = {
  itemId: undefined,
  title: "",
  description: "",
  price: 0,
  quantity: 0,
  discount: 0,
  trackingName: undefined,
  trackingOption: undefined,
  account: "",
  tax: 0,
  total: 0,
};
export const emptyInvoicing = {
  referenceNumber: "",
  dueDate: undefined,
  notes: "",
  documents: [],
  total: 0,
};

export const createInvoicingSchema = invoicingSchema;
export type CreateDocketInvoicing = z.infer<typeof invoicingSchema>;
export type AddDocketInvoicing = z.infer<typeof addDocketInvoicingSchema>;
